import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault()
      const target = document.querySelector(href)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>EASYA</h3>
            <p>{t('landing.footer.description')}</p>
            <div className="social-links">
              <a
                href="https://t.me/EasyARU_Bot"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-telegram"></i>
              </a>
              <a
                href="https://vk.com/easyacademy"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-vk"></i>
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h3>{t('landing.footer.features')}</h3>
            <p>
              <a href="#features" onClick={(e) => handleSmoothScroll(e, '#features')}>
                {t('landing.footer.links.personalLearning')}
              </a>
            </p>
            <p>
              <a href="#features" onClick={(e) => handleSmoothScroll(e, '#features')}>
                {t('landing.footer.links.materials')}
              </a>
            </p>
            <p>
              <a href="#features" onClick={(e) => handleSmoothScroll(e, '#features')}>
                {t('landing.footer.links.organizer')}
              </a>
            </p>
            <p>
              <a href="#features" onClick={(e) => handleSmoothScroll(e, '#features')}>
                {t('landing.footer.links.finance')}
              </a>
            </p>
          </div>
          <div className="footer-section">
            <h3>{t('landing.footer.support')}</h3>
            <p>
              <a href="#">{t('landing.footer.help')}</a>
            </p>
            <p>
              <a href="#">{t('landing.footer.faq')}</a>
            </p>
            <p>
              <a href="#">{t('landing.footer.contacts')}</a>
            </p>
            <p>
              <a href="#">{t('landing.footer.documentation')}</a>
            </p>
          </div>
          <div className="footer-section">
            <h3>{t('landing.footer.company')}</h3>
            <p>
              <a href="#team" onClick={(e) => handleSmoothScroll(e, '#team')}>
                {t('landing.footer.about')}
              </a>
            </p>
            <p>
              <a href="#news" onClick={(e) => handleSmoothScroll(e, '#news')}>
                {t('landing.footer.news')}
              </a>
            </p>
            <p>
              <a href="#">{t('landing.footer.career')}</a>
            </p>
            <p>
              <a href="#">{t('landing.footer.partners')}</a>
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; 2022 - {currentYear} EASYA. {t('landing.footer.rights')}. {t('landing.footer.poweredBy')}{' '}
            <a href="#" style={{ color: 'var(--primary-color)' }}>
              Oleg Mikhaylov
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
